import styled, { withTheme } from 'styled-components';
import { FormGroup as bootstrapFormGroup } from '@bootstrap-styled/v4';

const FormGroup = styled(bootstrapFormGroup)`
    margin:0 0 15px 0;
    &.form-group-error {
        label {
            color:${props => props.theme.$red};
        }
        input[type=text], select {
            color:${props => props.theme.$red};
            border:2px solid ${props => props.theme.$red} !important;
            ${props => props.theme.mixinPlaceHolder(`
                color:${props.theme.$red};
            `)}
        }
        .radio-container {
            border:2px solid ${props => props.theme.$red} !important;
            border-radius:3px;
            background: ${props => props.theme.$white} !important;
        }
        .input-error {
            display:block;
            padding:5px 0 0 12px;
            font-size: ${props => props.theme['$font-size-16']};
            color:${props => props.theme.$red};
            font-style: normal;
            font-family: ${props => props.theme['$font-family-sans-serif-regular']};
                    
        }
    }
`;

export default withTheme(FormGroup);
